import { defineComponent as _defineComponent } from 'vue';
import { BCard, BTab, BTabs } from "bootstrap-vue";
import { useFileSources } from "@/composables/fileSources";
import ToLink from "./ToLink.vue";
import ToRemoteFile from "./ToRemoteFile.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        historyId: null
    },
    setup(__props) {
        const props = __props;
        const { isLoading: initializingFileSources, hasWritable: hasWritableFileSources } = useFileSources();
        return { __sfc: true, initializingFileSources, hasWritableFileSources, props, BCard, BTab, BTabs, ToLink, ToRemoteFile, LoadingSpan };
    }
});
